// Allows numbers, characters & blank spaces only
const regexFirstAndLastName = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

// Allows approx 10 numerical values
const mobileRegex = /^[0-9]{10}$/;

// Allows approx 5 numbers
const zipCodeRegex = /^[0-9]{5}$/;

// Allow only letter, Numbers, space and hyphen
const aptRegex = /^[a-zA-Z0-9_\-\s]+$/;

// Allow only letter and space
const fullNameRegex = /[^A-Za-z ]$/

// I am using in kitchen front end its working fine
const nameRegex = /^[A-Za-z\s]*$/


// Email Address regex Ref: https://stackoverflow.com/questions/46155/whats-the-best-way-to-validate-an-email-address-in-javascript
// const emailRegex = /\S+@\S+\.\S+/;
// const emailRegex = /\S+@\S+\.\S+/;
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/*
    Password Regex 
    Ref: https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
    Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character
    Password should be 8 characters long, with atleast one uppercase letter, one lowercase letter, one number and one special character
  */
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const signUpValidation = (dataObject) => {
  try {
    const {
      firstName = "",
      lastName = "",
      mobile = "",
      zipCode = "",
      email = "",
      password = "",
      confirmPassword = "",
    } = dataObject;

    let isValid = true;

    const errors = {
      firstName:
        firstName.length === 0
          ? "Required First Name"
          : regexFirstAndLastName.test(firstName)
            ? "special characters / symbols not allowed"
            : "",
      lastName:
        lastName.length === 0
          ? "Required Last Name"
          : regexFirstAndLastName.test(lastName)
            ? "special characters / symbols not allowed"
            : "",
      // mobile:
      //   mobile.length === 0
      //     ? "Required Mobile Number"
      //     : mobileRegex.test(mobile)
      //       ? ""
      //       : "Invalid format",

      // zipCode:
      //   zipCode.length === 0
      //     ? "Required zipCode Number"
      //     : zipCodeRegex.test(zipCode)
      //       ? ""
      //       : "confirm password did not match with password",

      email:
        email.length === 0
          ? "Required email address"
          : emailRegex.test(email)
            ? ""
            : "Invalid email address",

      password:
        password.length === 0
          ? "Required password"
          : passwordRegex.test(password)
            ? ""
            : "Password should be 8 characters long, with atleast one uppercase letter, one lowercase letter, one number and one special character",

      confirmPassword:
        password.length === 0
          ? "Required password"
          : confirmPassword === password
            ? ""
            : "Confirmation password does not match the password.",
    };

    const errorData = {};

    for (let key in errors) {
      if (errors[key].length > 0) {
        isValid = false;
        errorData[key] = errors[key];
      }
    }

    if (isValid) {
      return null;
    }

    return errorData;
  } catch (e) {
    console.log("error in validation ", e);
  }
};

export const twoFeildValidation = (dataObject) => {
  try {
    const {
      firstName = "",
      lastName = "",
    } = dataObject;

    let isValid = true;

    const errors = {
      firstName:
        firstName.length === 0
          ? "Required First Name"
          : regexFirstAndLastName.test(firstName)
            ? "special characters / symbols not allowed"
            : "",
      lastName:
        lastName.length === 0
          ? "Required Last Name"
          : regexFirstAndLastName.test(lastName)
            ? "special characters / symbols not allowed"
            : "",

    };

    const errorData = {};

    for (let key in errors) {
      if (errors[key].length > 0) {
        isValid = false;
        errorData[key] = errors[key];
      }
    }

    if (isValid) {
      return null;
    }

    return errorData;
  } catch (e) {
    console.log("error in validation ", e);
  }
};


export const isValidEmail = (email) => emailRegex.test(email);
export const isValidZipcodeFormat = (zipcode) => zipCodeRegex.test(zipcode);
export const isValidAptNo = (apt) => aptRegex.test(apt);
export const isFullName = (fullname) => fullNameRegex.test(fullname);
export const isName = (name) => nameRegex.test(name);
